// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__H7d0z","close":"styles_close__deg92","title":"styles_title__3KJcb","content":"styles_content__2qsQb","saveWrap":"styles_saveWrap__IeV8m"};